// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/**\n * Assets Table Styles\n */\n.assets-table .asset-name-column {\n\tmax-width: 20vw;\n}\n", "",{"version":3,"sources":["AssetsTable.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;CACC,eAAe;AAChB","file":"AssetsTable.css","sourcesContent":["/**\n * Assets Table Styles\n */\n.assets-table .asset-name-column {\n\tmax-width: 20vw;\n}\n"]}]);
// Exports
module.exports = exports;
